import styled, { keyframes } from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  padding: 20px;
  width: 80%;
  max-width: 1000px;
  border-radius: 4px;
  max-height: 90vh;
  overflow: hidden;
  outline: none;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: 10px;

  h1 {
    font-size: 20px;
    font-weight: bold;
  }
`;

export const PDFContainer = styled.div`
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  padding: 10px;
  box-sizing: border-box;
`;

export const Button = styled.button<{ disabled?: boolean }>`
  padding: 10px 20px;
  width: 100%;
  background: ${(props) => (props.disabled ? "#ccc" : "#C7A25C")};
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  margin-right: 10px;
`;

export const ErrorMessage = styled.div`
  color: red;
  text-align: center;
  margin: 20px 0;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #c7a25c;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: ${spin} 1s linear infinite;
  margin: 20px auto;
`;
